import React from 'react';
import './PetAnimations.css';

export default function WispSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#B8D8F0';
  const lightColor = color ? lighten(color) : '#DCF0FF';
  const darkColor = color ? darken(color) : '#88B8D8';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer glow */}
      <circle cx="60" cy="50" r="38" fill={lightColor} opacity="0.08" />
      <circle cx="60" cy="50" r="32" fill={lightColor} opacity="0.12" />
      {/* Trailing sparkle particles */}
      <circle cx="45" cy="90" r="2" fill={lightColor} opacity="0.3" />
      <circle cx="55" cy="95" r="1.5" fill={bodyColor} opacity="0.25" />
      <circle cx="65" cy="92" r="1.8" fill={lightColor} opacity="0.2" />
      <circle cx="50" cy="100" r="1" fill={bodyColor} opacity="0.15" />
      <circle cx="70" cy="98" r="1.2" fill={lightColor} opacity="0.2" />
      <circle cx="40" cy="105" r="0.8" fill={bodyColor} opacity="0.1" />
      <circle cx="75" cy="105" r="1" fill={lightColor} opacity="0.1" />
      {/* Sparkles around body */}
      <path d="M28 35L30 32L32 35L30 38Z" fill="white" opacity="0.5" />
      <path d="M88 40L90 37L92 40L90 43Z" fill="white" opacity="0.4" />
      <path d="M35 65L37 63L39 65L37 67Z" fill="white" opacity="0.3" />
      <path d="M82 60L84 58L86 60L84 62Z" fill="white" opacity="0.35" />
      <path d="M25 55L26 53L27 55L26 57Z" fill="white" opacity="0.25" />
      {/* Wispy tail / trailing form */}
      <path
        d="M52 75C48 82 44 88 48 92C52 88 56 84 60 80C64 84 68 88 72 92C76 88 72 82 68 75"
        fill={bodyColor}
        opacity="0.4"
      />
      <path
        d="M55 72C52 78 50 84 54 86"
        stroke={lightColor}
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
        opacity="0.3"
      />
      <path
        d="M65 72C68 78 70 84 66 86"
        stroke={lightColor}
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
        opacity="0.3"
      />
      {/* Main orb body */}
      <circle cx="60" cy="50" r="26" fill={bodyColor} opacity="0.8" />
      {/* Inner glow */}
      <circle cx="60" cy="48" r="18" fill={lightColor} opacity="0.4" />
      <circle cx="56" cy="44" r="10" fill="white" opacity="0.2" />
      {/* Eyes */}
      <ellipse cx="52" cy="46" rx="4" ry="4.5" fill="white" opacity="0.9" />
      <ellipse cx="68" cy="46" rx="4" ry="4.5" fill="white" opacity="0.9" />
      <ellipse cx="53" cy="46" rx="2.5" ry="3" fill="#4A6B8A" />
      <ellipse cx="69" cy="46" rx="2.5" ry="3" fill="#4A6B8A" />
      <circle cx="54" cy="44.5" r="1" fill="white" />
      <circle cx="70" cy="44.5" r="1" fill="white" />
      {/* Gentle smile */}
      <path d="M55 55C57 57 63 57 65 55" stroke={darkColor} strokeWidth="1" strokeLinecap="round" fill="none" opacity="0.6" />
      {/* Rosy cheeks */}
      <circle cx="48" cy="54" r="3" fill="#E8A0C0" opacity="0.2" />
      <circle cx="72" cy="54" r="3" fill="#E8A0C0" opacity="0.2" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
